<template>
    <div class="wechat_management_wrap">
        <div class="wechat_management_top">
            <div class="wechat_management_top_search">
                <el-input size="small" v-model="keywords" placeholder="请输入商品名称"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
            </div>
            <div class="wechat_management_top_handle">
                <el-button type="primary" size="small" @click="handleClickAdd()">添加商品</el-button>
            </div>
        </div>
        <div class="wechat_management_bottom">
            <CustomVxeTable
                    ref="tableRef"
                    class="custom-table"
                    id="wxChatTicketTable"
                    :tableData="tableData"
                    :reduceHeight="reduceHeight"
                    :loading="loading"
                    :isShowToolBar="true"
                    :empty-render="{ name: 'NotData' }"
                    :pagination.sync="pagination"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    :customConfig="tableCustomConfig">
                <vxe-column field="id" title="商品排序" align="center" width="90" show-overflow>
                    <template #default="{ row }">
                        <i class="iconfont icon-a-move"></i>
                    </template>
                </vxe-column>
                <vxe-column field="ticket_name" title="商品名称"  min-width="180" show-overflow></vxe-column>
                <vxe-column field="platform_name" title="平台"  min-width="142" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.platform_detail" v-text="row.platform_detail.platform_name"></span>
                    </template>
                </vxe-column>
                <vxe-column field="is_upper" title="商品状态"  min-width="142" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.platform_id == 1" v-text="row.is_upper == 1? '上架' : '下架'" :class="row.is_upper == 1 ? 'is_upper' : 'danger_text'"></span>
                        <span v-else>--</span>
                    </template>
                </vxe-column>
                <vxe-column field="price" title="商品金额"  min-width="142" show-overflow>
                    <template  #default="{ row }">
                        <span v-if="row.price" v-text="Number(row.price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>

                    </template>
                </vxe-column>
                <vxe-column field="created_at" title="创建时间"  min-width="142" show-overflow></vxe-column>
                <vxe-column field="create_user" title="创建人"  min-width="142" show-overflow>
                    <template #default="{ row }">
                        <userDetailPopover v-if="row.create_user && row.create_user.id" :uid="row.create_user.id">
                            <div slot="container">
                                <div class="ellipsis" v-text="(row.create_user && row.create_user.name) ? row.create_user.name : '-'"></div>
                            </div>
                        </userDetailPopover>
                    </template>
                </vxe-column>
                <vxe-column field="operate" width="90" fixed="right">
                    <template #header>
                        <span>操作</span>
<!--                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">-->
<!--                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>-->
<!--                        </el-tooltip>-->
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <span  class="handle_icon_wrap" @click.stop="handleClickEdit(row)"><i class="iconfont icon-bianji"></i></span>
                            <span  class="line"></span>
                            <span  class="handle_icon_wrap handle_icon_danger_wrap" @click.stop="handleClickDel(row)"><i class="iconfont icon-shanchu1"></i></span>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img"></div>
                        <p class="custom-table-empty-txt">暂无商品</p>
                        <div>
                            <el-button type="primary" plain size="small">添加商品</el-button>
                        </div>
                    </div>
                </template>

            </CustomVxeTable>
        </div>


        <ticketAdd :ticketVisible.sync="ticketVisible" :ticketId="ticketId" @success="getTableData" v-if="ticketVisible" />

    </div>
</template>
<script>
import { ticketList,ticketDel,ticketSort} from "@/api/index.js"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import ticketAdd from "../ticket_management/ticket_add"
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import Sortable from "sortablejs";
export default {
    name: 'WeChatTicket',
    components: {
        CustomVxeTable,
        ticketAdd,
        userDetailPopover
    },
    data () {
        return {
            loading:false,
            keywords:'',
            tableData:[],
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },
            ticketVisible:false,
            ticketId:0
        }
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 170 : 124;
        },
    },
    mounted () {
        this.getTableData()
        this.pullSort()
    },
    methods: {
        pullSort() {
            this.$nextTick(() => {
                const el = this.$refs.tableRef.$el.querySelectorAll(".vxe-table--body-wrapper > table > tbody")[0];
                this.sortable = new Sortable.create(el, {
                    handle: ".icon-a-move",//格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
                    animation: 600, //拖拽动画(毫秒)
                    setData: function (dataTransfer) {
                        dataTransfer.setData("Text", "");
                    },
                    // 开始拖拽
                    onStart: (evt) => {

                    },
                    // 结束拖拽
                    onEnd: (evt) => {
                        const {oldIndex, newIndex} = evt;
                        let data = JSON.parse(JSON.stringify(this.tableData))
                        const targetRow =  data.splice(evt.oldIndex, 1)[0]
                        data.splice(evt.newIndex, 0, targetRow)
                        let info = data.map((item,key)=>{
                            return {id:item.id,sort:(this.pagination.pageNum-1) * this.pagination.pageSize +key+1}
                        })

                        this.loading = true
                        ticketSort({data:info}).then(res=> {
                            if(res.code === 200) {
                                this.$message.success('操作成功')
                            }
                            this.loading = false
                        })
                    },
                });
            })
        },
        // 新增
        handleClickAdd(){
            this.ticketId = 0
            this.ticketVisible = true
        },
        // 编辑
        handleClickEdit(row){
            this.ticketId = row.id
            this.ticketVisible = true
        },
        // 删除
        handleClickDel(row){
            const h = this.$createElement;
            let text = row.platform_id == 1 ?'删除后，小程序用户端也一并删除该商品，无法购买'  : '确定删除吗？删除后将无法核销该商品'
            this.$msgbox({
                title: '删除',
                message: h('div', null, [
                    h('span', null, text),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText:   '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                   ticket_id : row.id
                }
                this.loading = true
                ticketDel(postData).then(res=> {
                    if(res.code === 200) {
                       this.$message.success('删除成功')
                       this.getTableData()
                    }
                    this.loading = false
                })
            }).catch(() => {

            })
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.keywords
            }
            this.loading = true
           ticketList(postData).then(res=> {
               if(res.code === 200) {
                   let {data,total} = res.data
                   this.tableData = data
                   this.pagination.total = total
               }
               this.loading = false
           })

        },
    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
</style>
